/**
 * widgets/registry.addonstore.tsx — Addon Store (2.1).
 * Core stránka (/core/store); module undefined = vždy dostupné (nezašedne
 * kvůli neexistujícímu modulu „addonstore").
 */
import { Box, Globe, Home, Layers } from 'lucide-react';
import type { WidgetSpec } from './types';
import { ModulesBrowsePanel } from '../pages/modules/ModulesBrowse';
import {
  AvailablePanel,
  HaAddonsPanel,
  InstalledPanel,
} from '../pages/modules/addonstore/panels';

export const ADDONSTORE_WIDGETS: WidgetSpec[] = [
  {
    id: 'addonstore.browse',
    title: 'Modules overview',
    kind: 'custom',
    format: 'lg',
    formats: ['md', 'lg'],
    icon: Layers,
    since: '2.1.0',
    component: ModulesBrowsePanel,
  },
  {
    id: 'addonstore.installed',
    title: 'Installed modules',
    kind: 'custom',
    format: 'lg',
    formats: ['md', 'lg'],
    icon: Box,
    since: '2.1.0',
    component: InstalledPanel,
  },
  {
    id: 'addonstore.available',
    title: 'Available modules',
    kind: 'custom',
    format: 'lg',
    formats: ['md', 'lg'],
    icon: Globe,
    since: '2.1.0',
    component: AvailablePanel,
  },
  {
    id: 'addonstore.ha',
    title: 'HA / HACS addons',
    kind: 'custom',
    format: 'lg',
    formats: ['md', 'lg'],
    icon: Home,
    since: '2.1.0',
    component: HaAddonsPanel,
  },
];
